import { Injectable, DestroyRef, inject } from '@angular/core';
import { AuthFacade } from '@lentau/auth/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { combineLatest, debounceTime, filter } from 'rxjs';
import { DeliveryModeFacade } from '@lentau/delivery-mode/store/delivery-mode.facade';
import { UserAuthorizeType } from '@lentau/auth/shared/enums';
import { DefaultStoreFacade } from '@lentau/address/default-store/store/default-store.facade';
import { PlatformService } from '@lentau/ui-kit/core/services/platform/platform.service';

@Injectable({
  providedIn: 'root',
})
export class AddressesRequestService {
  private authFacade: AuthFacade = inject(AuthFacade);
  private destroyRef: DestroyRef = inject(DestroyRef);
  private defaultStoreFacade: DefaultStoreFacade = inject(DefaultStoreFacade);
  private deliveryModeFacade: DeliveryModeFacade = inject(DeliveryModeFacade);
  private platformService: PlatformService = inject(PlatformService);

  public getAddressesForClient(): void {
    // Ожидаем установки дефолтного магазина или сигнала о том что его устанавливать не надо.
    // isLoggedOut$ нужен, чтобы перезапросить delivery mode при разлогине, когда userAuthorizeType
    // не меняется (гость после failed refresh → logoutSuccess). Для авторизованного разлогина
    // тип и isLoggedOut меняются одним patchState — debounceTime(0) схлопывает в один вызов.
    combineLatest([
      this.authFacade.userAuthorizeType$,
      this.defaultStoreFacade.loading$,
      this.defaultStoreFacade.waitingForCheck$,
      this.authFacade.isLoggedOut$,
    ])
      .pipe(
        debounceTime(0),
        filter(
          ([type, loading, waitingForCheck]: [UserAuthorizeType | null, boolean, boolean, boolean]) =>
            !!type && !loading && !waitingForCheck
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.loadAddresses());
  }

  public loadAddresses(): void {
    if (this.platformService.isServer) return;

    this.deliveryModeFacade.getDeliveryMode();
    this.deliveryModeFacade.pickupStoreSearch();
  }
}
